import styles from './CompletionModalWindow.module.scss';
import Box from '@components/Box';
import CheckIcon from '@assets/icons/check_62.svg';
import parse from 'html-react-parser';
import { Button } from '@components/Button';
import { Column, Row } from '@components/Grid';
import { ICompletionModalWindowProps } from './types';
import { Text, TextColor, TextSize } from '@components/Text';
import { TextWeight } from '@components/Text';

const CompletionModalWindow: React.FC<ICompletionModalWindowProps> = (props: ICompletionModalWindowProps): React.ReactElement => {
  const {
    btnText,
    description,
    handlerSetIsOpenModalWindow,
    icon,
    title
  } = props;

  return (
      <div className={styles.grid}>
        <Row>
          <Column phone={12}>
            <Box mb={5}>
              <img
                  src={icon ?? CheckIcon}
                  alt={icon ? 'icon' : 'check'}
              />
            </Box>
          </Column>
        </Row>
        <Row>
          <Column phone={12}>
            <Box
                mb={description ? 3 : 5}
                textAlign="center"
            >
              <Text
                  color={TextColor.PRIMARY}
                  size={TextSize.XL}
                  weight={TextWeight.BOLD}
              >
                {parse(title)}
              </Text>
            </Box>
          </Column>
        </Row>
        {description && (
            <Row>
              <Column phone={12}>
                <Box
                    mb={5}
                    textAlign="center"
                >
                  <Text
                      color={TextColor.PRIMARY}
                      size={TextSize.S}
                  >
                    {parse(description)}
                  </Text>
                </Box>
              </Column>
            </Row>
        )}
        <Row>
          <Box>
            <Button
                onClick={handlerSetIsOpenModalWindow}
                title={btnText}
            />
          </Box>
        </Row>
      </div>
  );
};

export default CompletionModalWindow;